import { borderStyles, fontStyles, globalStyles, iconStyles } from 'styles/theme';

import FlexContainer from 'components/common/FlexContainer';
import { Info } from 'react-feather';
import { TranslationIcon } from 'types/translation';
import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export const Container = styled.div({
  margin: '16px 12% 80px',
  display: 'flex',
  flexDirection: 'column',
  [mobileMediaQuery]: {
    margin: '0px 0px 80px',
  },
});

export const TabPaneTabContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px 16px',
  gap: 8,
});

export const TabContentIntro = styled(FlexContainer)({
  padding: '32px 0px 16px',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: 8,
  [mobileMediaQuery]: {
    padding: '32px 0 16px 20px',
  },
});

export const Description = styled.span({
  fontSize: fontStyles.sizes.xl,
});

export const TooltipIcon = styled(Info)({
  width: 20,
  height: 20,
  color: iconStyles.colors.primary,
});

export const TabBadge = styled.div({
  backgroundColor: globalStyles.colors.transparent,
  border: `1px solid ${borderStyles.colors.primary}`,
  borderRadius: 6,
  fontSize: fontStyles.sizes.xs,
  padding: 2,
});

export type Props = {
  title: string;
  numberOfResults: number;
  icon?: TranslationIcon;
};

export function TabPaneTab(props: Props): JSX.Element {
  const { icon, numberOfResults, title } = props;
  return (
    <TabPaneTabContainer className='tab-pane-tab'>
      {icon && <img alt='' src={`./config/icons/${icon.src}`} />}
      {title}
      <TabBadge className='tab-pane-badge'>{numberOfResults}</TabBadge>
    </TabPaneTabContainer>
  );
}
